"use strict";
/**
 * @packageDocumentation
 * @module harmony-transaction
 * @hidden
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractTransaction = void 0;
var AbstractTransaction = /** @class */ (function () {
    function AbstractTransaction() {
    }
    return AbstractTransaction;
}());
exports.AbstractTransaction = AbstractTransaction;
//# sourceMappingURL=abstractTransaction.js.map